import { isArray } from 'lodash';

// Pull a human-readable message out of the error thrown by the API
// adapter (`utils/Api/handleError`). That error carries
// `apiErrors` — for a JSON:API response it's an ARRAY of
// `{ status, source, title }`; some legacy endpoints still return
// an OBJECT (e.g. `{ error, user: [...], profile: [...] }`). Both
// shapes are flattened to a newline-joined string so the saga can
// show it in a toast.
//
// Before this, a failed seafarer save (validation error returned
// as a blanket 500) set `submitError` but nothing was ever shown —
// the form just sat on "Saving…" with no reason (2026-06-09
// reports). Now the actual message ("Check phones: there are
// duplicates!", "Seafarer is already exist…", etc.) reaches the
// user.
export default function apiErrorMessage(error, fallback = 'Could not save. Please try again.') {
  const api = error?.apiErrors;

  if (isArray(api)) {
    const titles = api.map((e) => e?.title).filter(Boolean);
    if (titles.length) return [...new Set(titles)].join('\n');
  } else if (api && typeof api === 'object') {
    const parts = Object.values(api).flat().filter((p) => p != null && p !== '');
    if (parts.length) return [...new Set(parts.map(String))].join('\n');
  }

  return error?.message || fallback;
}
